/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Modal, Button, Input } from 'antd';
import {
  ModalBody,
  ModalContainer,
  PasswordLabel,
  LoginContainer,
  InputContainer,
  PasswordContainer,
  InputLabel
} from './styles';
import { VerifyPassword, createCustomerPortal } from '../../utils/services/authAPI';
import md5 from 'md5';
import { BILLING_PASSWORD_MODAL } from './translationValues';

const BillingPassword = props => {
  const { visible, onCancel, t } = props;
  const [password, setPassword] = useState('');
  const [savingLoader, setSavingLoader] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [fielddError, setFieldError] = useState(false);

  const PasswordHandler = async () => {
    setSavingLoader(true);
    let payload = {
      password: md5(password)
    };

    // verify password
    let verifyResponse = await VerifyPassword(payload);

    // create createCustomerPortal after verified password
    if (verifyResponse?.isVerified) {
      setIsValidPassword(true);
      const billingResponse = await createCustomerPortal();

      if (billingResponse?.sessionUrl) {
        window.open(billingResponse?.sessionUrl);
        onCancel();
      }
    } else {
      setFieldError(true);
    }
    setSavingLoader(false);
  };

  const handleKeyPress = e => {
    if (password && e.key === 'Enter') {
      PasswordHandler();
    }
  };

  const closeModal = () => {
    setPassword('');
    onCancel();
  };

  // Prevent  paste and copy behavior
  const preventAction = (e) => {
    e.preventDefault();
  };

  const renderPassword = () => (
    <InputContainer>
      <PasswordLabel>{t(BILLING_PASSWORD_MODAL.ENTER_PASSWORD_TITLE.key, BILLING_PASSWORD_MODAL.ENTER_PASSWORD_TITLE.value)}</PasswordLabel>
      <PasswordLabel desc={true}>
        {t(BILLING_PASSWORD_MODAL.RE_ENTER_PASSWORD_DESCRIPTION.key, BILLING_PASSWORD_MODAL.RE_ENTER_PASSWORD_DESCRIPTION.value)}
      </PasswordLabel>
      <Input.Password
        size="large"
        placeholder={t(BILLING_PASSWORD_MODAL.ENTER_PASSWORD_PLACEHOLDER.key, BILLING_PASSWORD_MODAL.ENTER_PASSWORD_PLACEHOLDER.value)}
        value={password}
        onChange={e => {
          setPassword(e.target.value);
          setFieldError(false);
        }}
        onPaste={preventAction}
        onCopy={preventAction}
      />
      {fielddError && <InputLabel signUp error className="bottom_top_anime">
        {t(BILLING_PASSWORD_MODAL.INVALID_CREDENTIAL_ERROR_MESSAGE.key, BILLING_PASSWORD_MODAL.INVALID_CREDENTIAL_ERROR_MESSAGE.value)}
      </InputLabel>}
    </InputContainer>
  );

  return (
    <LoginContainer onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title=""
        centered
        visible={visible}
        width="625px"
        onCancel={closeModal}
        // closable={false}
        maskClosable={false}
        footer={[
          <Button
            key="submit"
            type="primary"
            disabled={!password}
            loading={savingLoader}
            onClick={PasswordHandler}
          >
            {savingLoader ? t(BILLING_PASSWORD_MODAL.VERIFING_PASSWORD_BUTTON_TEXT.key, BILLING_PASSWORD_MODAL.VERIFING_PASSWORD_BUTTON_TEXT.value) : t(BILLING_PASSWORD_MODAL.PROCEED_BUTTON.key, BILLING_PASSWORD_MODAL.PROCEED_BUTTON.value)}
          </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <PasswordContainer isValidPassword={isValidPassword}>
            <div className="lockContainer">
              <input id="inpLock" type="checkbox" checked={!isValidPassword} />
              <label class="btn-lock" for="inpLock">
                <svg width="36" height="40" viewBox="0 0 36 40">
                  <path
                    class="lockb"
                    d="M27 27C27 34.1797 21.1797 40 14 40C6.8203 40 1 34.1797 1 27C1 19.8203 6.8203 14 14 14C21.1797 14 27 19.8203 27 27ZM15.6298 26.5191C16.4544 25.9845 17 25.056 17 24C17 22.3431 15.6569 21 14 21C12.3431 21 11 22.3431 11 24C11 25.056 11.5456 25.9845 12.3702 26.5191L11 32H17L15.6298 26.5191Z"
                  ></path>
                  <path
                    class="lock"
                    d="M6 21V10C6 5.58172 9.58172 2 14 2V2C18.4183 2 22 5.58172 22 10V21"
                  ></path>
                  <path class="bling" d="M29 20L31 22"></path>
                  <path class="bling" d="M31.5 15H34.5"></path>
                  <path class="bling" d="M29 10L31 8"></path>
                </svg>
              </label>
            </div>
            <ModalContainer>{renderPassword()}</ModalContainer>
          </PasswordContainer>
        </ModalBody>
      </Modal>
    </LoginContainer>
  );
};

export default withTranslation(['BILLING_PASSWORD_MODAL'])(BillingPassword);
